import { render, staticRenderFns } from "./faqs.vue?vue&type=template&id=b3a97c36&scoped=true&"
import script from "./faqs.vue?vue&type=script&lang=js&"
export * from "./faqs.vue?vue&type=script&lang=js&"
import style0 from "./faqs.vue?vue&type=style&index=0&id=b3a97c36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a97c36",
  null
  
)

export default component.exports